import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './cargo-model';
import VehicleStateImg from './vehicle-state-img';
import WindowImg from '../../assets/images/cargo-model/window.png';

class VehicleWindow extends React.Component<VehicleModelProps, any> {
  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler('window');
  };

  render() {
    const { className, vehicleState } = this.props;

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState.window}`}
        src={WindowImg}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleWindow = styled(VehicleWindow)`
  position: relative;
  z-index: 1;
  width: 7.2em;
  top: -0.35em;
`;

export default StyledVehicleWindow;
